import {editorProps} from '../../slack';

export const createDefaultContent = (text: string = '') => {
  return {
    children: [
      {
        "text": text,
        html: '', // used as `defaultValue` by the WYSIWYG editor
      }
    ]
  }
};

export const getParagraphEditorValue = (content: any) => {
  if (!content.children) {
    return '';
  }
  return content.children[0].html || content.children[0].text;
}

const TOOLBAR: string = 'removeformat | ' +
  'bold italic strikethrough | ' +
  'backcolor forecolor | ' +
  'alignleft aligncenter alignright alignjustify | ' +
  'outdent indent | ' +
  'link | ' +
  'numlist bullist | ' +
  'blockquote | ' +
  'removeformat';

const _getHeader = (editor: any): any => editor.editorContainer.querySelector('.tox-editor-header');
const _getStatusBar = (editor: any): any => editor.editorContainer.querySelector('.tox-statusbar');
const _setHeight = (editor: any, height: string): any => editor.editorContainer.style.height = height;

const onBlur = (editor: any) => {
  _setHeight(editor, '144px');
  const header = _getHeader(editor);
  const statusBar = _getStatusBar(editor);

  if (header) {
    header.classList.add('hide')
  }
  if (statusBar) {
    statusBar.classList.add('hide')
  }
}

export const getEditorProps = () => {
  const initialProps = editorProps();

  return {
    ...initialProps,
    height: 144,
    min_height: 192,
    max_height: 345, // 10 lines + menu + statusbar
    menubar: 'edit format insert',
    plugins: 'link emoticons lists',
    toolbar: TOOLBAR,
    branding: false,
    paste_as_text: true,
    promotion: false,
    statusbar: true,
    elementpath: false,
    setup: (editor: any) => {
      let mouseDown = false;

      editor.on('mousedown', (event: any) => {
        /*
         * Only allow triggering `focus` if `mousedown` event was called before.
         * This way we avoid `focus` on drag and drop
         */
        mouseDown = true;
      });

      editor.on('blur', (event: any) => {
        onBlur(editor);
      });

      editor.on('focus', (event: any) => {
        /*
         * on DnD, do not trigger onFocus
         */

        if (!mouseDown) {
          return;
        }
        mouseDown = false;

        _setHeight(editor, '258px'); // 6 lines
        const header = _getHeader(editor);
        const statusBar = _getStatusBar(editor);

        if (header) {
          header.classList.remove('hide')
        }
        if (statusBar) {
          statusBar.classList.remove('hide')
        }
      });
    },
    init_instance_callback: (editor: any) => {
      onBlur(editor);
    }
  };
};
